import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateMaintenanceWindowSimpleScheduler = document.createElement('template');

templateMaintenanceWindowSimpleScheduler.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper">

    <gz-title fontSize="11" fontWeight="600" class="subsection-title" id="scheduler-title"/></gz-title>

    <div class="form-section">

      <gz-form-field id='recurrence-form-field' class='label-mw-250' required>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <div class="details-container">

        <div class="form-section hidden" id="recurrence-daily-container">
          <gz-form-field id="daily-at-form-field" class='label-mw-250' required>
            <gz-time-picker gz-form-input></gz-time-picker>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div class="form-section hidden" id="recurrence-weekly-container">
          <gz-form-field id='weekly-on-days-form-field' class='label-mw-250' required>
            <gz-multiselect-group gz-form-input></gz-multiselect-group>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-form-field id="weekly-at-form-field" class='label-mw-250' required>
            <gz-time-picker gz-form-input></gz-time-picker>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

      </div>
    </div>
    <br>
  </div>
`;
